import type { PolicyGetResponse } from '@lio/api-types';

/**
 * Returns the destination policy this policy has been continued into (i.e. the related policy with a
 * `ContinuedFrom` relationship), if one exists. Used to surface the "continued with" banner and to
 * disable renewal actions on a policy that has already been continued.
 */
export const getContinuedToPolicy = (relatedPolicyDestinations?: PolicyGetResponse['relatedPolicyDestinations']) =>
  relatedPolicyDestinations?.find((relation) => relation.policyRelationType === 'ContinuedFrom')?.destinationPolicy;
